import { render, staticRenderFns } from "./CatalogSearchBar.vue?vue&type=template&id=82d67556"
import script from "./CatalogSearchBar.vue?vue&type=script&lang=js"
export * from "./CatalogSearchBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports